import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { upperCaseFirstLetter } from 'common/utils/utils';
import {
   useDynamicComponentImport,
} from 'admin/views/site-designer/data';

// Example usage
const SectionComponent = ({ type, component, value, onChange, sectionName, limit, isPrepearComponentForRender, fullSrc }) => {
   const getPath = () => {
      let fileName = type

      if(type?.includes('-')) {
         fileName = type.split('-')
            .map(word => upperCaseFirstLetter(word))
            .join('')

      } else if(type?.includes('_')){
         fileName = type.split('_')
            .map(word => upperCaseFirstLetter(word))
            .join('')
      }
      else {
         fileName = upperCaseFirstLetter(type);
      }
      return fileName;
   }

   const { Component, isLoadComponent, notFoundComponent } = useDynamicComponentImport(getPath(), 'admin/views/site-designer/modules/sections/components');

   const props = {
      ...component,
      value: value,
      onChange: onChange,
      sectionName: sectionName,
      limit: limit,
      fullSrc: fullSrc,
   }
   const loadingComponentHeight = component?.loadingComponentHeight || '88px';
   const loadSection = isPrepearComponentForRender || isLoadComponent;
   return (
      <Suspense
         fallback={
            <div
               className='loading-bg bg-placeholder rounded-lg w-full my-auto'
               style={ {
                  height: loadingComponentHeight,
               } } />
         }
      >
         {
            notFoundComponent && (
               <span className='text-placeholder text-base font-medium'>
                  {upperCaseFirstLetter(type)} Component not found
               </span>
            )
         }
         {
            !loadSection && !notFoundComponent && (
               <Component
                  { ...props }
               />
            )}
         {
            loadSection && (
               <div
                  style={ {
                     height: loadingComponentHeight,
                  } }
                  className='loading-bg bg-placeholder rounded-lg w-full my-auto flex items-center justify-center'>
                  {
                     (!Component && !isPrepearComponentForRender) && `${ upperCaseFirstLetter(type) } Component not found`
                  }
               </div>
            )
         }
      </Suspense>
   );
};

SectionComponent.propTypes = {
   component: PropTypes.object,
   type: PropTypes.string,
   value: PropTypes.any,
   onChange: PropTypes.func,
   fullSrc: PropTypes.string,
   sectionName: PropTypes.string,
   limit: PropTypes.number,
   sectionLoad: PropTypes.bool,
   isPrepearComponentForRender: PropTypes.bool,
}

export default SectionComponent;
